// extracted by mini-css-extract-plugin
module.exports = {"container":"footer-module--container--3jyK_","spacer":"footer-module--spacer--2G2Ga"};